import {
    FREE_AMOUNT_ON_ORDER,
    FREE_AMOUNT_ON_PRODUCT,
    FREE_PRODUCT,
    PERCENT_ON_ORDER,
    PERCENT_ON_PRODUCT,
} from "@constants";
import { t } from "i18next";
import { snapshot } from "valtio";

import { kioskStore } from "../store";

export function handleCodePromoSymbole(discountType: number): string {
    const { devise } = snapshot(kioskStore);
    switch (discountType) {
        case PERCENT_ON_ORDER:
        case PERCENT_ON_PRODUCT:
            return "%";
        case FREE_AMOUNT_ON_ORDER:
        case FREE_AMOUNT_ON_PRODUCT:
            return devise.deviseSymbole || "€";
        case FREE_PRODUCT:
            return t("Free");
        default:
            return "";
    }
}
